import { render, staticRenderFns } from "./DanhSachQuyenTrongGroup.vue?vue&type=template&id=79fbfd20&"
import script from "./DanhSachQuyenTrongGroup.vue?vue&type=script&lang=js&"
export * from "./DanhSachQuyenTrongGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports